module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_hamburger-0756956aad3a5bc2a846d23357db6423.svg";